interface PlayModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

export default function PlayModal({ open, title, onClose }: PlayModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-background-50/80 p-4 backdrop-blur-sm animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-xl border border-background-300/60 bg-background-100 p-6 text-center md:p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-accent-500/15 text-accent-500 animate-pulse-ring">
          <i className="ri-play-fill text-3xl"></i>
        </div>
        <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">播放功能演示中</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-400">
          你正在查看《{title}》的播放入口。本站为演示版本，<span className="text-foreground-700">播放接口尚未接入</span>，
          点击播放不会真正开始播放视频，仅用于展示完整的产品浏览体验。
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-primary-500 px-6 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            我知道了
          </button>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-background-300/70 px-6 py-2.5 text-sm text-foreground-500 transition-colors hover:text-foreground-950 cursor-pointer whitespace-nowrap"
          >
            返回浏览
          </button>
        </div>
        <p className="mt-4 text-xs text-foreground-300">演示状态 · 不提供真实播放服务</p>
      </div>
    </div>
  );
}